module.exports = __webpack_public_path__ + "media/images/iconbox/icon8-c136029ed425a64c38983a91e793168e.png";